import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '../components/Avatar';
import { PageHeader } from '../components/PageHeader';
import { PublicVisibilityControls } from '../components/PublicVisibilityControls';
import { Button } from '../components/ui/Button';
import { Card, SectionTitle } from '../components/ui/Card';
import { people } from '../data/people';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
export function EditProfile() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    profile,
    updateProfile
  } = useMetrics();
  const [draft, setDraft] = useState(profile);
  const fields = [{
    id: 'name' as const,
    label: 'profile.field.name'
  }, {
    id: 'username' as const,
    label: 'profile.field.username'
  }];
  return <div className="px-2 pb-2" data-id="element-2419" data-mp="totacpoykpi5">
      <PageHeader title={t('profile.edit')} showBack data-id="element-2420" data-mp="yljnp59dp6zv" />

      <Card className="p-2" data-id="element-2421" data-mp="yl04zmbwmeks">
        <div className="flex items-center gap-2" data-id="element-2422" data-mp="3ik76ee79f3tu">
          <Avatar src={people[0].avatar} name={draft.name} size={64} data-id="element-2423" data-mp="3iiw1gb22vq15" />
          <div className="min-w-0 flex-1" data-id="element-2424" data-mp="3ej55lsxp2jpr">
            <p className="text-[13px] font-medium text-deep" data-id="element-2425" data-mp="3eic71f8w30ip">
              {t('profile.photo')}
            </p>
            <p className="mt-[2px] text-[11.5px] leading-snug text-muted" data-id="element-2426" data-mp="3sgagq7c9m8rv">
              {t('profile.photoHint')}
            </p>
          </div>
        </div>
      </Card>

      <Card className="mt-2 p-2" data-id="element-2427" data-mp="2zuh9nljxs7za">
        <SectionTitle data-id="element-2428" data-mp="2zrcz86fvog06">{t('profile.identity')}</SectionTitle>
        {fields.map(field => <label key={field.id} className="mt-2 block first:mt-0" data-id="element-2429" data-mp="2usrze84jfyc9">
            <span className="bee-overline text-[9px] font-bold text-muted" data-id="element-2430" data-mp="39kal8mk2wn3j">
              {t(field.label)}
            </span>
            <input value={draft[field.id]} onChange={event => setDraft({
          ...draft,
          [field.id]: event.target.value
        })} className="mt-1 h-11 w-full rounded-card border border-sand-line bg-white/80 px-2 text-[13.5px] text-deep focus:border-deep/40" data-id="element-2431" data-mp="34qpn8uihjt4c" />
          </label>)}

        <label className="mt-2 block" data-id="element-2432" data-mp="kys8u7wqefbu">
          <span className="bee-overline text-[9px] font-bold text-muted" data-id="element-2433" data-mp="kxqkx2um9ycp">
            {t('profile.field.bio')}
          </span>
          <textarea value={draft.bio} rows={3} onChange={event => setDraft({
          ...draft,
          bio: event.target.value
        })} className="mt-1 w-full resize-none rounded-card border border-sand-line bg-white/80 p-2 text-[13.5px] leading-relaxed text-deep focus:border-deep/40" data-id="element-2434" data-mp="tswu8bt3iyjz" />
        </label>
      </Card>

      <div className="mt-3" data-id="element-2435" data-mp="61hoe9241z3z">
        <PublicVisibilityControls data-id="element-2436" data-mp="b1vxzvjd1h44" />
      </div>

      <Button variant="gold" size="lg" fullWidth className="mt-3" onClick={() => {
      updateProfile(draft);
      navigate('/perfil');
    }} data-id="element-2437" data-mp="b2ov04sios92">
        {t('common.save')}
      </Button>
    </div>;
}